/**
 * 把下次复习时间说成孩子听得懂的话:今天 / 明天 / 后天 / N 天后
 * 按本地日历日算,不按 24 小时算(晚上 9 点学会的,"明天"就是第二天)
 */
export function describeNextReview(iso, now = new Date()) {
  if (!iso) return '过几天';
  const due = new Date(iso);
  const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOf(due) - startOf(now)) / 86400000);
  if (days <= 0) return '今天';
  if (days === 1) return '明天';
  if (days === 2) return '后天';
  return `${days} 天后`;
}
